<template>
    <div class="row">
        <div class="col-12 mb-1">
            <b-alert show variant="warning" class="mb-1">
                <div class="d-flex align-items-start">
                    <feather-icon icon="AlertTriangleIcon" class="mr-50 mt-25"></feather-icon>
                    <div>
                        <strong>Şablon güncellendi.</strong> Lütfen yalnızca <u>güncel (yeni) Basit Şablonu</u> indirip doldurun.
                        Eski şablonla yükleme, verilerin yanlış kolonlara kaydedilmesine yol açar.
                    </div>
                </div>
            </b-alert>

            <b-button v-b-toggle.upload-column-order size="sm" variant="outline-secondary" class="mb-1">
                <feather-icon icon="ListIcon" class="mr-50"></feather-icon>
                Şablon kolon sırası
            </b-button>
            <b-collapse id="upload-column-order">
                <div class="border rounded p-1 mb-1">
                    <p class="mb-50 text-muted small">
                        Yüklenecek Basit Şablonun kolon sırası aşağıdaki gibidir.
                        <span class="text-warning font-weight-bold">Sarı</span> işaretli kolonları siz doldurursunuz; diğerleri sistem tarafından gelir ve değiştirilmemelidir.
                        <span class="font-weight-bold">TMS-KOD</span> kolonuna asla dokunmayın.
                    </p>
                    <div class="table-responsive">
                        <table class="table table-sm table-bordered mb-0">
                            <thead>
                                <tr><th style="width:60px">Sıra</th><th>Kolon</th></tr>
                            </thead>
                            <tbody>
                                <tr v-for="col in columnOrder" :key="col.index" :class="col.fill ? 'table-warning' : ''">
                                    <td class="text-center">{{ col.index }}</td>
                                    <td>{{ col.name }}<span v-if="col.fill" class="text-muted small"> (doldurulacak)</span></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </b-collapse>

            <label class="form-label">Excel</label>
            <v-file-uploader v-model="value" :accept="['xlsx','xls']" value-parameter="File"></v-file-uploader>
        </div>
    </div>
</template>

<script>
import VFileUploader from '@/components/v-file-uploader/VFileUploader.vue'
export default {
    components:{
        VFileUploader
    },
    props:{
        value:Object
    },
    data(){
        return {
            // Banka 2 Basit Şablon nihai kolon sırası. fill=true => kullanıcının doldurduğu + upload'ın okuduğu kolonlar.
            columnOrder:[
                {index:1, name:'Sıra'},
                {index:2, name:'Adı Soyadı'},
                {index:3, name:'Sicil Numarası'},
                {index:4, name:'Plaka'},
                {index:5, name:'Unvan'},
                {index:6, name:'Şube [Fiili]'},
                {index:7, name:'Maaş [Baz]'},
                {index:8, name:'ÜTGS [Ücrete Tabi Gün Sayısı]'},
                {index:9, name:'Giriş Tarihi'},
                {index:10, name:'Çıkış Tarihi'},
                {index:11, name:'YİGS [Yıllık İzin Gün Sayısı]'},
                {index:12, name:'İİGS [İdari İzin Gün Sayısı]'},
                {index:13, name:'ÜTOGS [Ücrete Tabi Olmayan Gün Sayısı]'},
                {index:14, name:'Maaş [Baz Fiili]'},
                {index:15, name:'YİÜ [Yıllık İzin Ücreti]'},
                {index:16, name:'FMÜ [Fazla Mesai Ücreti]', fill:true},
                {index:17, name:'FMÜ [Bayram] [Fazla Mesai Ücreti Bayram]', fill:true},
                {index:18, name:'Yemek Ücreti', fill:true},
                {index:19, name:'Yol Ücreti', fill:true},
                {index:20, name:'Prim (KM-Ton)', fill:true},
                {index:21, name:'Prim [Destek]', fill:true},
                {index:22, name:'Prim [Yakıt]', fill:true},
                {index:23, name:'Hamaliye Ücreti', fill:true},
                {index:24, name:'Bekleme', fill:true},
                {index:25, name:'Prim [Toplam]'},
                {index:26, name:'ODÖ [Olağandışı Ödemeler]', fill:true},
                {index:27, name:'Açıklama', fill:true},
                {index:28, name:'Toplam Hakediş'},
                {index:29, name:'Hatalar'},
                {index:30, name:'TMS-KOD'},
            ]
        }
    }
}
</script>